module.exports = __webpack_public_path__ + "img/404@2x.acc165de.png";